import React from 'react';
import { Box, Card, CardActionArea, Typography } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import EventIcon from '@mui/icons-material/Event';
import TvIcon from '@mui/icons-material/Tv';
import RepeatIcon from '@mui/icons-material/Repeat';
import TuneIcon from '@mui/icons-material/Tune';
import ListAltIcon from '@mui/icons-material/ListAlt';
import PlaceIcon from '@mui/icons-material/Place';
import StoreIcon from '@mui/icons-material/Store';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import EuroIcon from '@mui/icons-material/Euro';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useNavigate } from 'react-router-dom';
import { CardGrid, PageHeader, SectionTitle } from './common';

const SECTIONS: { title: string; entries: { icon: React.ReactElement; title: string; text: string; path: string }[] }[] = [
  {
    title: 'Conta',
    entries: [
      { icon: <PersonOutlineIcon />, title: 'A minha conta', text: 'Foto, nome e palavra-passe', path: '/casa/conta' },
    ],
  },
  {
    title: 'Casa',
    entries: [
      { icon: <PeopleIcon />, title: 'Casa e pessoas', text: 'Quem vive cá e horas das refeições', path: '/casa/agregado' },
      { icon: <EventIcon />, title: 'Calendários', text: 'Os calendários de cada um e o da casa, na Semana', path: '/casa/eventos/calendarios' },
      { icon: <TvIcon />, title: 'Painel da casa', text: 'O dia ou a semana de cada um, para um tablet ou televisão', path: '/casa/painel' },
      { icon: <RepeatIcon />, title: 'Padrões das refeições', text: 'Quem come em cada refeição da semana', path: '/casa/refeicoes/padroes' },
      { icon: <TuneIcon />, title: 'Regras das sugestões', text: 'O que a sugestão da semana tem em conta', path: '/casa/refeicoes/regras' },
    ],
  },
  {
    title: 'Compras',
    entries: [
      { icon: <ListAltIcon />, title: 'Catálogo de artigos', text: 'Os artigos das receitas, da lista e de casa', path: '/casa/catalogo' },
      { icon: <PlaceIcon />, title: 'Locais e zonas', text: 'Onde guardas as coisas em casa', path: '/casa/em-casa/locais' },
      { icon: <StoreIcon />, title: 'Lojas', text: 'Onde compras e a ordem dos corredores', path: '/casa/compras/lojas' },
      { icon: <EventRepeatIcon />, title: 'Compras regulares', text: 'O que compras de tempos a tempos', path: '/casa/compras/regulares' },
    ],
  },
  {
    title: 'Finanças',
    entries: [
      { icon: <EuroIcon />, title: 'Despesas', text: 'Despesas e receitas da casa', path: '/expenses/home-expenses' },
    ],
  },
];

/** Everything that is not used every day, as in the Android "Mais" tab. */
const MorePage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <PageHeader title="Mais" subtitle="O que não usas todos os dias" />
      {SECTIONS.map(section => (
        <React.Fragment key={section.title}>
          <SectionTitle>{section.title}</SectionTitle>
          <CardGrid min={280}>
            {section.entries.map(entry => (
              <Card key={entry.path}>
                <CardActionArea onClick={() => navigate(entry.path)} sx={{ p: 2, display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-start', gap: 1.5 }}>
                  <Box sx={{ width: 40, height: 40, borderRadius: 2.5, flexShrink: 0, display: 'grid', placeItems: 'center', bgcolor: 'action.selected', color: 'primary.main' }}>
                    {entry.icon}
                  </Box>
                  <Box sx={{ minWidth: 0 }}>
                    <Typography sx={{ fontWeight: 650 }}>{entry.title}</Typography>
                    <Typography variant="body2" color="text.secondary">{entry.text}</Typography>
                  </Box>
                </CardActionArea>
              </Card>
            ))}
          </CardGrid>
        </React.Fragment>
      ))}
    </>
  );
};

export default MorePage;
